import  { Fragment, useLayoutEffect, useState } from 'react';
import './App.css';
import Home from './components/Home';
import Navbar from './components/Navbar';
import About from './components/About';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Contact from './components/Contact';
import Footer from './components/Footer';

const App = () => {
  
  const [width, setWidth] = useState(0);
  var showMobileNavbar = false;

  useLayoutEffect(() => {
    function updateSize(){
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  if(width < 576){
    showMobileNavbar = true;
  }
  else{
    showMobileNavbar = false;
  }

  return (
    <Fragment>
      <Home />
      <Navbar showMobileNavbar={showMobileNavbar}  />
      <About />
      <Projects />
      <Experience />
      <Contact />
      <Footer />
    </Fragment>
  );
}

export default App;
